const styles = theme => ({
  root: {
    padding: theme.spacing(2),
  },
})

export default styles
